import React, { useEffect } from "react";

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Paper,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import MUIIcon from "../ui/MUIIcon";

const SimpleTable = ({ config, data }) => {
  const theme = useTheme();

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {config.actions?.map((action, idx) => (
                <TableCell
                  key={`action-${idx}`}
                  sx={{ width: "32px" }}
                >
                  {action.label}
                </TableCell>
              ))}
              {config.columns.map((column, idx) => (
                <TableCell
                  key={`column-${idx}`}
                  sx={column.sx}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((record, recordIdx) => (
              <TableRow key={`row-${record.id || recordIdx}`}>
                {config.actions?.map((action, actionIdx) => (
                  <TableCell
                    key={`action-${record.id}-${actionIdx}`}
                    sx={{ width: "24px" }}
                  >
                    <MUIIcon
                      name={action.iconName}
                      size="18px"
                      color={theme.palette.primary.main}
                      onClick={() => action.onClick(record.id)}
                    />
                  </TableCell>
                ))}
                {config.columns.map((column, colIdx) => (
                  <TableCell key={`cell-${record.id}-${colIdx}`}>
                    {column.format
                      ? column.format(record[column.name])
                      : record[column.name]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SimpleTable;
